import React from 'react';
import { createRoot } from "react-dom/client";

import "./scss/custom.scss";
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById("root");
const root = createRoot(container);

if (process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'test' || process.env.NODE_ENV !== 'development') {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    root.render(<App />);
}

reportWebVitals();